import React, { forwardRef,  useImperativeHandle,useState, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import Commons from "../../../util/commons";
import Tippy from '@tippyjs/react';


const AllFieldsRenderer = forwardRef((props, ref) => {
    const { t } = useTranslation();

    const [borderClass, setBorderClass] = useState("sales-grid-row");

    useImperativeHandle(ref, () => {
        return {
            refresh(params) {

            }
        };
    });

    useEffect(() => {
        if (props.node.data != null) {
            var addcls = props.node.data ? props.node.data.cancellationMark ? "row-canceled-status" : props.node.data.mark ? "row-sended-status" : "row-not-sended-status" : "";
            setBorderClass("sales-grid-row " + addcls);

        }
    }, [props.node])

    const rowData = <div className="container sales-aggrid-tooltip-inner">
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b >{t("InvoiceType")}:</b></div>
            <div className="p-1 bd-highlight"><span >{props.data ? props.data.invoiceTypeName : ""}</span></div>
        </div>
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b>{t("Customer")}:</b></div>
            <div className="p-1 bd-highlight"><span>{props.data ? props.data.customerName : ""} ({props.data ? props.data.customerTaxPayerId : ""})</span></div>
        </div>
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b >{t("issuerDate")}:</b></div>
            <div className="p-1 bd-highlight"><span>{props.data ? props.data.invoiceDate : ""}</span></div>
        </div>
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b >{t("TotalWithoutVat")}:</b></div>
            <div className="p-1 bd-highlight"><span>{props.data ? Commons.formatNumber(props.data.totalWithoutVat) : ""}</span></div>
        </div>
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b >{t("TotalWithVat")}:</b></div>
            <div className="p-1 bd-highlight"><span>{props.data ? Commons.formatNumber(props.data.totalWithVat) : ""}</span></div>
        </div>
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b >{t("TotalPayment")}:</b></div>
            <div className="p-1 bd-highlight"><span>{props.data ? Commons.formatNumber(props.data.totalPayment) : ""}</span></div>
        </div>
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b >{t("Status")}:</b></div>
            <div className="p-1 bd-highlight"><span> {props.data ? props.data.mark ? props.data.cancelationMark ? <span className="badge bg-danger">{t("canceled")}</span> : <span className="badge bg-success">{t("sended")}</span> : <span className="badge bg-secondary">{t("notInMyData")}</span> : ""}</span></div>
        </div>
    </div>;

    const inconsistencyIcon = props.node.data ? (props.node.data.hasInconsistency ? <Tippy trigger="click" content={t("incosistncyIconInfo")} ><i className='fa fa-exclamation-circle incosistncyIconInfo'></i></Tippy> : <></>) : <></>;

    return (

        <div className={borderClass}>

            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 bd-highlight"><span >
                    <Tippy trigger="click" content={rowData}>
                        <i className="fa fa-info-circle" style={{ marginRight: 6 }}></i>
                    </Tippy>
                    <b>{props.data ? props.data.seriesNumber + " " : ""}</b>
                </span><span >{props.data ? props.data.invoiceTypeName : ""}</span></div>
            </div>

            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 bd-highlight"><span style={{ fontStyle: "italic" }}>{props.data ? props.data.customerName + " (" + props.data.customerTaxPayerId + ")" : ""}</span></div>
            </div>
            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 flex-grow-1 bd-highlight"><span >{props.data ? props.data.invoiceDate : ""}</span></div>
                {inconsistencyIcon}
                <div className="p-0 bd-highlight"><span> {props.data ? props.data.cancellationMark ? <span className="tooltip-canceled-status">{props.data.cancellationMark}</span> : props.data.mark ? <span className="tooltip-sended-status">{props.data.mark}</span> : <span className="tooltip-not-sended-status">{t("notInMyData")}</span> : ""}</span></div>

                {/* <div className="p-0 bd-highlight"><span> {props.data?props.data.cancelationMark?<span className="tooltip-canceled-status">{t("canceled")}</span>:<span className="tooltip-sended-status">{t("sended")}</span>:<span className="tooltip-not-sended-status">{t("notInMyData")}</span>}</span></div> */}
            </div>

            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 flex-grow-1 bd-highlight"><span >{t("VatAmount")}: </span><span ><b>{props.data ? Commons.formatNumber((props.data.totalWithVat - props.data.totalWithoutVat).toFixed(2)) : 0.00}</b></span></div>
                <div className="p-0 bd-highlight"><span >{t("TotalPaymentMin")}: </span><span ><b>{props.data ? Commons.formatNumber(props.data.totalPayment.toFixed(2)) : 0.00}</b></span></div>
            </div>

            {/* <div className="d-flex bd-highlight allFieldsColumnRow">
                <table className="table table-borderless">
                    <thead >
                        <tr>
                            <th>{t("TotalWithVatMin")}</th> <th>{t("TotalWithoutVatMin")}</th> <th>{t("TotalPaymentMin")}</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr>
                            <td>{props.data ? props.data.totalWithoutVat.toFixed(2) : 0.00}</td> <td>{props.data ? props.data.totalWithoutVat.toFixed(2) : 0.00}</td> <td>{props.data ? props.data.totalPayment.toFixed(2) : 0.00}</td>
                        </tr>
                    </tbody>
                </table>
            </div> */}
        </div >
    );
});


export default AllFieldsRenderer;